const filters_form = document.querySelector( '#filter-form' );
const filters = document.querySelectorAll( '#filter-form .filter' );

filters.forEach( function ( filter ) {

  filter.addEventListener( 'change', function() {

    if ( filter.value !== '' ) {

      filters_form.submit();

    }

  } )

} );

